import React from 'react';
import { connect } from "react-redux";

import _ from "lodash";
import { ReportContext } from '../view';

import Cell from '../components/cell';
import Timeseries from '../components/timeseries';
import EntityReport from '../components/reports';
import PerformanceDetailReport from './components.jsx';
import { Asset, Contact, Deal } from '../components/entities';

import {
  COLLECTION, USER, USER_GROUP
} from "../../../constants/entities"

import styles from '../reports.module.scss';
import { localizedStrings } from '../../../../localization/index';
import { resetReportDownload } from 'src/legacy/redux/actions/reports';

const mapDispatchToProps = (dispatch) => {
  return {
    resetReportDownload: () => dispatch(resetReportDownload()),
  };
};

class PerformanceReportView extends React.Component {

  constructor(props) {
    super(props);

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedHeaders = this.localizedReport.tabs.commons.headers;
  }

  componentDidMount() {
    this.props.trackAdoptionMetricsForReportsToggledViewEvent('Performance');
  }

  render() {
    return (
      <ReportContext.Consumer>
        {(contextObj) => (
          <div className={styles.grid}>
            <Cell column={2}>
              <InteractionReport request={contextObj.filter} fetchData={(request) => {
                this.props.fetchPerformanceInteractionsGraphReport(request);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell className={styles.leads}>
              <LeadsTimeSeriesReport request={contextObj.filter} fetchData={(request) => {
                this.props.fetchPerformanceLeadsGraphReport(request);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
              <LeadsReport request={contextObj.filter} fetchData={(request, page, limit) => {
                this.props.fetchLeadsDetailReport(request, page, limit);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell className={styles.deals}>
              <DealsTimeSeriesReport request={contextObj.filter} fetchData={(request) => {
                this.props.fetchPerformanceDealsGraphReport(request);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
              <DealsReport request={contextObj.filter} fetchData={(request, page, limit) => {
                this.props.fetchDealsDetailReport(request, page, limit);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell>
              <DealValueTimeSeriesReport request={contextObj.filter} fetchData={(request) => {
                this.props.fetchPerformanceDealValueGraphReport(request);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell >
              <ClosedDealsTimeSeriesReport request={contextObj.filter} fetchData={(request) => {
                this.props.fetchPerformanceClosedDealsGraphReport(request);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell>
              <ClosedDealValueTimeSeriesReport request={contextObj.filter} fetchData={(request) => {
                this.props.fetchPerformanceClosedDealValueGraphReport(request);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell >
              <TopContentLeadsReport request={contextObj.filter} fetchData={(request, page, limit) => {
                this.props.fetchPerformanceTopContentGeneratingLeads(request, page, limit);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
            <Cell >
              <TopContentDealsReport request={contextObj.filter} fetchData={(request, page, limit) => {
                this.props.fetchPerformanceTopContentClosedDeals(request, page, limit);
              }}
                downloadReport={(id, request, page, limit) => this.props.downloadReport(id, request, page, limit)}
                download={this.props.download}
              />
            </Cell>
          </div>
        )}
      </ReportContext.Consumer>
    );
  }
}

const InteractionReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.performance.interactions.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedPerformance = localizedReport.tabs.performance;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;
    return {
      title: `${localizedPerformance.cards.interactions} (${count})`,
      loading: state.legacyRootReducer.reports.performance.interactions.loading,
      data: state.legacyRootReducer.reports.performance.interactions.item,
      supportedEntities: [COLLECTION, USER, USER_GROUP],
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.performance.interactions
      },
      tooltipText: localizedPerformance.cards.tooltip_texts.interactions_content
    };
  }
)(Timeseries);

const LeadsTimeSeriesReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.performance.leads.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedPerformance = localizedReport.tabs.performance;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;

    return {
      title: `${localizedPerformance.cards.leads} (${count})`,
      loading: state.legacyRootReducer.reports.performance.leads.loading,
      data: state.legacyRootReducer.reports.performance.leads.item,
      supportedEntities: [COLLECTION, USER, USER_GROUP],
      className: styles.leads,
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.performance.leads
      },
      tooltipText: localizedPerformance.cards.tooltip_texts.leads,
      
    };
  }
)(Timeseries);

const DealsTimeSeriesReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.performance.deals.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedPerformance = localizedReport.tabs.performance;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;

    return {
      title: `${localizedPerformance.cards.deals} (${count})`,
      loading: state.legacyRootReducer.reports.performance.deals.loading,
      data: state.legacyRootReducer.reports.performance.deals.item,
      supportedEntities: [COLLECTION, USER, USER_GROUP],
      className: styles.deals,
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.performance.deals
      },
      tooltipText: localizedPerformance.cards.tooltip_texts.deals
    };
  }
)(Timeseries);

const DealValueTimeSeriesReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.performance.dealValue.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedPerformance = localizedReport.tabs.performance;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;

    return {
      title: `${localizedPerformance.cards.deal_value} (${count})`,
      loading: state.legacyRootReducer.reports.performance.dealValue.loading,
      data: state.legacyRootReducer.reports.performance.dealValue.item,
      supportedEntities: [COLLECTION, USER, USER_GROUP],
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.performance.deal_value
      },
      tooltipText: localizedPerformance.cards.tooltip_texts.deal_value
    };
  }
)(Timeseries);

const ClosedDealsTimeSeriesReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.performance.closedDeals.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedPerformance = localizedReport.tabs.performance;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;

    return {
      title: `${localizedPerformance.cards.closed_deals} (${count})`,
      loading: state.legacyRootReducer.reports.performance.closedDeals.loading,
      data: state.legacyRootReducer.reports.performance.closedDeals.item,
      supportedEntities: [COLLECTION, USER, USER_GROUP],
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.performance.closed_deals
      },
      tooltipText: localizedPerformance.cards.tooltip_texts.closed_deals
    };
  }
)(Timeseries);

const ClosedDealValueTimeSeriesReport = connect(
  (state, ownProps) => {
    let count = _.sumBy(state.legacyRootReducer.reports.performance.closedDealValue.item, (item) => item.value);
    const localizedReport = localizedStrings.pages.reports;
    const localizedPerformance = localizedReport.tabs.performance;
    const localizedTooltips = localizedStrings.pages.reports.tabs.commons.tool_tips;

    return {
      title: `${localizedPerformance.cards.closed_deal_value} (${count})`,
      loading: state.legacyRootReducer.reports.performance.closedDealValue.loading,
      data: state.legacyRootReducer.reports.performance.closedDealValue.item,
      supportedEntities: [COLLECTION, USER, USER_GROUP],
      legend: {
        key: localizedTooltips.date,
        value: localizedTooltips.performance.closed_deal_value
      },
      tooltipText: localizedPerformance.cards.tooltip_texts.closed_deal_value
    };
  }
)(Timeseries);

const TopContentLeadsReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.performance.topLeadsContent, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedPerformance = localizedReport.tabs.performance;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "performance_content_leads",
      title: `${localizedPerformance.cards.generate_leads} (${count})`,
      

      className: styles.leads,
      list: {
        renderer: Asset.Lead.List
      },
      grid: {
        renderer: Asset.Lead.Grid,
        columns: [{
          title: '',
          width: 6
        }, {
          title: localizedHeaders.interactions,
          width: 2
        }, {
          title: localizedHeaders.leads,
          width: 2
        }]
      },
      supportedEntities: [COLLECTION, USER, USER_GROUP],
      data: state.legacyRootReducer.reports.performance.topLeadsContent,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.content_used], [localizedHeaders.total_interactions], [localizedHeaders.total_leads]],
        fileName: "PerformanceContentLeads.csv"
      },
      tooltipText: localizedPerformance.cards.tooltip_texts.content_generate_leads
    }
  }, mapDispatchToProps
)(EntityReport);

const TopContentDealsReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.performance.contentClosedDeals, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedPerformance = localizedReport.tabs.performance;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "performance_content_deals",
      title: `${localizedPerformance.cards.content_that_closed_deals} (${count})`,
      

      className: styles.deals,
      list: {
        renderer: Asset.Deal.List
      },
      grid: {
        renderer: Asset.Deal.Grid,
        columns: [{
          title: '',
          width: 6
        }, {
          title: localizedHeaders.interactions,
          width: 2
        }, {
          title: localizedHeaders.deals,
          width: 2
        }]
      },
      supportedEntities: [COLLECTION, USER, USER_GROUP],
      data: state.legacyRootReducer.reports.performance.contentClosedDeals,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.content_used], [localizedHeaders.total_interactions], [localizedHeaders.total_deals_closed]],
        fileName: "PerformanceContentDeals.csv"
      },
      tooltipText: localizedPerformance.cards.tooltip_texts.content_closed_deals
    }
  }, mapDispatchToProps
)(EntityReport);

const LeadsReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.performance.leadsDetail, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedPerformance = localizedReport.tabs.performance;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "performance_leads",
      title: `${localizedPerformance.cards.leads_detail} (${count})`,
      

      className: styles.leads,
      grid: {
        renderer: Contact.Lead.Grid,
        columns: [{
          title: '',
          width: 4
        }, {
          title: localizedHeaders.date_added,
          width: 2
        }, {
          title: localizedHeaders.account,
          width: 2
        }, {
          title: localizedHeaders.content_used,
          width: 4
        }]
      },
      supportedEntities: [COLLECTION, USER, USER_GROUP],
      data: state.legacyRootReducer.reports.performance.leadsDetail,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.name], [localizedHeaders.email], [localizedHeaders.account], [localizedHeaders.date_added], [localizedHeaders.content_used]],
        fileName: "PerformanceLeads.csv"
      },
      tooltipText: localizedPerformance.cards.tooltip_texts.leads
    }
  }
)(PerformanceDetailReport);


const DealsReport = connect(
  (state, ownProps) => {
    let count = _.get(state.legacyRootReducer.reports.performance.dealsDetail, 'pagination.totalRecordsCount', 0);
    const localizedReport = localizedStrings.pages.reports;
    const localizedPerformance = localizedReport.tabs.performance;
    const localizedHeaders = localizedReport.tabs.commons.headers;
    return {
      id: "performance_deals",
      title: `${localizedPerformance.cards.deals_detail} (${count})`,
      

      className: styles.deals,
      grid: {
        renderer: Deal.Grid,
        columns: [{
          title: localizedHeaders.deal_title,
          width: 3
        }, {
          title: localizedHeaders.date_added,
          width: 2
        }, {
          title: localizedHeaders.value,
          width: 2
        }, {
          title: localizedHeaders.status,
          width: 2
        }, {
          title: localizedHeaders.content_used,
          width: 3
        }]
      },
      supportedEntities: [COLLECTION, USER, USER_GROUP],
      data: state.legacyRootReducer.reports.performance.dealsDetail,
      fetchData: ownProps.fetchData,
      downloadProperties: {
        headers: [[localizedHeaders.deal], [localizedHeaders.deal_value], [localizedHeaders.deal_stage], [localizedHeaders.created_date]],
        fileName: "PerformanceDeals.csv"
      },
      tooltipText: localizedPerformance.cards.tooltip_texts.deals
    }
  }
)(PerformanceDetailReport);



export default PerformanceReportView;    